module.exports = __webpack_public_path__ + "img/logo.0a9e16dd.svg";